import {createSelector} from '@ngrx/store';
import {State} from '../../../reducers';
import * as fromCompany from './company.reducer';

export const companies = (state: State) => state.companies;

export const selectCompanies = createSelector(companies, (state: fromCompany.State) => state.companies);
